module.exports = __webpack_public_path__ + "static/img/statistics-icon.4df32f50.svg";